"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'project.icon.help': 'Wprowadź klasę ikony FontAwesome (np. fas fa-folder)',
};
